import { render, staticRenderFns } from "./ProcessingRequestLanding.vue?vue&type=template&id=61e41e8b&scoped=true"
import script from "./ProcessingRequestLanding.vue?vue&type=script&lang=js"
export * from "./ProcessingRequestLanding.vue?vue&type=script&lang=js"
import style0 from "./ProcessingRequestLanding.vue?vue&type=style&index=0&id=61e41e8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e41e8b",
  null
  
)

export default component.exports